import useInterval from '@use-it/interval'
import OpenModal from '../CMSComponent/Forms/Fields/openModal'
import PublicFooter from './Footer/footer'
import PublicHeader from './Header/header'
import { useHistory, useLocation } from 'react-router-dom'
import { fetchUpdateApiData } from '../Redux/Reducers/CMS'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { checkIsMaintainanceRoute } from '../helper'
import { normalizeCheckoutEmailFromUrl, savePublicCheckoutContactEmail } from '../Helper/publicPageHelper'
import MaintainanceNotice from './PageSpecificComponents/MaintainanceBanner/maintainanceNotice'
import { checkIsFutureDate, checkIsPastDate, convertDateInLocalTimezone } from '../dateHelper'
import { PublicPageContextProvider } from '../Context/publicPageContext'

const PublicPageWrapper = ({ children }) => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const updateApiData = useSelector((state) => state.CMS?.updateApiData)
  const show_alert_form = updateApiData?.site_maintenance?.show_alert_from
  const start_date = updateApiData?.site_maintenance?.start_date
  const searchParams = new URLSearchParams(location.search)
  const isShowOnlyContent = searchParams.get('isShowOnlyContent')

  useEffect(() => {
    dispatch(fetchUpdateApiData())
  }, [])

  /**
   * Email deep links (same storage as guest locker booking):
   * - `/?email=user%40domain.com` or `/?email=user@domain.com`
   * - `/email/user%40domain.com` (single path segment after `/email/`)
   * Then remove email from URL.
   */
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const fromQuery = params.get('email')
    const pathMatch = location.pathname.match(/^\/email\/([^/]+)$/i)
    const fromPath = pathMatch?.[1]

    const raw = fromQuery || fromPath
    if (!raw) return

    const email = normalizeCheckoutEmailFromUrl(raw)
    if (!email) return

    savePublicCheckoutContactEmail(email)

    if (fromQuery) {
      params.delete('email')
      const qs = params.toString()
      history.replace({
        pathname: location.pathname,
        search: qs ? `?${qs}` : '',
        hash: location.hash || '',
      })
    } else {
      const qs = params.toString()
      history.replace({
        pathname: '/',
        search: qs ? `?${qs}` : '',
        hash: location.hash || '',
      })
    }
  }, [location.pathname, location.search, location.hash, history])

  useInterval(() => {
    if (localStorage.getItem('IS_INTERNET_ACTIVE')) {
    } else {
      dispatch(fetchUpdateApiData())
    }
  }, 60 * 1000)

  return (
    <PublicPageContextProvider>
      {!isShowOnlyContent && !checkIsMaintainanceRoute() && <PublicHeader />}
      {start_date && checkIsFutureDate(convertDateInLocalTimezone(start_date)) && checkIsPastDate(convertDateInLocalTimezone(show_alert_form)) && (
        <MaintainanceNotice />
      )}
      {updateApiData?.show_banner && !isShowOnlyContent && <div className='bg-danger subtitle2 text-light text-center py-1'>Test</div>}

      {children}
      {!isShowOnlyContent && !checkIsMaintainanceRoute() && <PublicFooter />}
      <OpenModal />
    </PublicPageContextProvider>
  )
}

export default PublicPageWrapper
